(async () => {
  let isUpdatingCart = false;
  async function updateCart(e) {
    if (isUpdatingCart) return;
    isUpdatingCart = true;
    const cart = await fetch("/cart.js").then((response) => response.json());
    const fixedCart = bndlr.updateCartWithDiscounts(cart);
    if (fixedCart.total_amount_original > fixedCart.total_amount_discounted) {
      document
        .querySelectorAll(
          ".totals__subtotal-value, .basket-total, .saso-cart-total",
        )
        .forEach((el) => {
          el.innerHTML = Shopify.formatMoney(
            fixedCart.total_amount_discounted,
            cartGlobal.money_format,
          );
        });
      document
        .querySelectorAll(".free-shipping-text")
        .forEach((el) =>  {
          /**
            * Re-render the equivelent of the liquid code below:
            *               {% if cart.total_price >= minimum_order %}
                <div style="margin: 0;font-weight: 700;font-size: 12px;">{{ settings.qualified_text }} </div>
              {% else %}
                <div style="margin: 0;font-weight: 700;font-size: 12px;">{{ settings.progress_text | replace: '[remaining]', remaining }} </div>
              {% endif %}
              <div class="progress-bar">
                <span class="current-progress"  style="width:{{ cart.total_price | divided_by: minimum_order | times: 100 }}%"></span>
              </div>
            */
            const minimum_order = el.dataset.minimumOrder;
            const total_price = fixedCart.total_amount_discounted;
            const qualified_text = el.dataset.qualifiedText;
            const progress_text = el.dataset.progressText;
            const remaining = Shopify.formatMoney(minimum_order - total_price, cartGlobal.money_format);
            const progress = (total_price / minimum_order) * 100;
            el.innerHTML = `
              ${
                total_price >= minimum_order
                  ? `<div style="margin: 0;font-weight: 700;font-size: 12px;">${qualified_text}</div>`
                  : `<div style="margin: 0;font-weight: 700;font-size: 12px;">${progress_text.replace(
                      "[remaining]",
                      remaining,
                    )}</div>`
              }
              <div class="progress-bar">
                <span class="current-progress" style="width:${progress}%"></span>
              </div>
          `;
        });
    }
    const dicountedCart = fixedCart.discounted_cart_object;

    for (const item of dicountedCart.items) {
      const discount = item.original_line_price - item.line_price;
      if (discount <= 0) continue;
      const regular_price_per = item.original_line_price;
      const sale_price_per = item.line_price;
      const regular_price_per_item = item.original_line_price / item.quantity;
      const sale_price_per_item = item.line_price / item.quantity;
      const regular_price = Shopify.formatMoney(
        regular_price_per,
        cartGlobal.money_format,
      );
      const sale_price = Shopify.formatMoney(
        sale_price_per,
        cartGlobal.money_format,
      );
      const regular_price_item = Shopify.formatMoney(
        regular_price_per_item,
        cartGlobal.money_format,
      );
      const sale_price_item = Shopify.formatMoney(
        sale_price_per_item,
        cartGlobal.money_format,
      );

      const price_item_html = `
                          <div class="cart-item__discounted-prices">

                            <s class="cart-item__old-price product-option">
        ${regular_price_item}
                            </s>

                              <span class="saso-cart-item-price" data-key="{{item.key}}"><strong class="cart-item__final-price product-option">
        ${sale_price_item}
                            </strong></span>
      `;

      document
        .querySelectorAll(
          `.cart-item[key="${item.key}"] .cart-item__discounted-prices`,
        )
        .forEach((el) => {
          el.insertAdjacentHTML("afterend", price_item_html);
          el.remove();
        });

      const html = `
      <div class="saso-cart-item-line-price cart-item__price-wrapper"><div class="cart-item__discounted-prices">
                                <span class="visually-hidden">
                                  Regular price
                                </span>
                                <s class="cart-item__old-price price price--end">
                                  ${regular_price} 
                                </s>
                                <span class="visually-hidden">
                                  Sale price
                                </span>
                                <span class="price price--end">
                                  ${sale_price}
                                </span>
                              </div></div>
      `;
      document
        .querySelectorAll(
          `.cart-item[key="${item.key}"] .cart-item__price-wrapper`,
        )
        .forEach((el) => {
          el.insertAdjacentHTML("afterend", html);
          el.remove();
        });
    }
    isUpdatingCart = false;
    console.log("End updating cart");
  }
  document.addEventListener("cart:updated", (e) => updateCart(e));

  await new Promise((resolve) => {
    const interval = setInterval(() => {
      if (
        typeof Shopify !== "undefined" &&
        typeof Shopify.formatMoney === "function"
      ) {
        clearInterval(interval);
        resolve();
      }
    });
  });
  updateCart();
})();
